/**
 * Generates a compact text summary of the menu for the Claude system prompt.
 * Keeps token count low (~2-4KB) while giving the LLM enough structure
 * to know where to search with tools.
 */
export default function buildMenuSummary(shop) {
  const shopId = shop.get ? shop.get('shopId') : shop.shopId
  const shopName = shop.get
    ? (shop.get('name') && shop.get('name').en)
    : (shop.name && shop.name.en)

  const lines = [`Shop: ${shopName || shopId} (id: ${shopId})`]
  lines.push('Submenus:')

  const subMenus = shop.subMenus || []
  for (const sm of subMenus) {
    const name = sm.get ? (sm.get('name') && sm.get('name').en) : (sm.name && sm.name.en)
    const section = sm.get ? sm.get('section') : sm.section
    const draft = sm.get ? sm.get('draft') : sm.draft
    const products = sm.products || []
    const draftLabel = draft ? ', DRAFT' : ''
    lines.push(`  - "${name}" (id: ${sm.id}, section: ${section || 'none'}${draftLabel}, ${products.length} products)`)
  }

  return lines.join('\n')
}
